<div class="popup_header">
   <strong class="popup_title">{{popupTitle}} <span class="template_url">mypage-common-dialog</span></strong>
   <button type="button" class="popup_close" (click)="popupClose()"><span class="blind">팝업 닫기</span></button>
</div>
<div class="popup_content" *ngIf="type == 'addChannel'">
   <p class="popup_desc">본인의 채널 정보를 입력해 주세요.</p>
   <div class="form mt-14">
       <div class="select">
           <select class="select_current" [(ngModel)]="userChannel.channelType">
               <option value="">::선택하세요::</option>
               <option value="CH01">유튜브</option>
               <option value="CH02">SNS</option>
               <option value="CH03">블로그</option>
               <option value="CH04">카페</option>
               <option value="CH99">기타</option>
           </select>
       </div>
       <input type="text" [(ngModel)]="userChannel.channelUrl" class="form_input" placeholder="https://"/>
   </div>
   <div class="account_form">
       <input type="text" class="form_input" placeholder="스크린 샷을 등록해 주세요."  disabled [(ngModel)]="screenshotFileName" />
       <input type="file" id="screeshotFiles" class="blind" accept="image/*" (change)="onScreenshotFileChange(screenshotFileInput.files, $event.target)" #screenshotFileInput />
       <label for="screeshotFiles" class="form_button btn_required">첨부</label>
   </div>
</div>
<div class="popup_content" *ngIf="type == 'addScreenshot'">
   <p class="popup_desc">활동하시는 개인 채널의 스크린 샷을 등록해 주세요.</p>
   <div class="account_form">
       <input type="text" class="form_input" placeholder="스크린 샷을 등록해 주세요."  disabled [(ngModel)]="screenshotFileName" />
       <input type="file" id="screeshotFiles" class="blind" accept="image/*" (change)="onScreenshotFileChange(screenshotFileInput.files, $event.target)" #screenshotFileInput />
       <label for="screeshotFiles" class="form_button btn_required">첨부</label>
   </div>
</div>
<div class="popup_content" *ngIf="type == 'updateCorpCode'">
   <span class="popup_box_gray account_box" *ngIf="user.corpCode">등록된 사업자번호 : {{user.corpCode | corpCode}},&nbsp;&nbsp;세금계산서 {{user.cashbillYn === 'Y' ? '제공' : '미제공'}}</span>
   <p class="popup_desc">변경할 사업자 정보를 입력해 주세요.</p>
   <div class="account_form">
       <div class="license_input">
        <input type="text" [(ngModel)]="corpCodePart1" class="form_input" placeholder="000" maxlength="3" />
        <span class="dash"></span>
        <input type="text" [(ngModel)]="corpCodePart2" class="form_input" placeholder="00" maxlength="2" />
        <span class="dash"></span>
        <input type="text" [(ngModel)]="corpCodePart3" class="form_input" placeholder="00000" maxlength="5" />
       </div>
   </div>
   <div class="account_form">
        <input type="text" id="attachedFile" class="form_input" placeholder="사업자 등록증을 첨부해 주세요." readonly [(ngModel)]="licenseFileName" />
        <input type="file" id="controlFiles" name="controlFiles" class="blind" (change)="onFileChange(fileInput.files, $event.target)" #fileInput/>
        <label for="controlFiles" class="form_button btn_required">첨부</label>
   </div>
   <br>
   <p class="popup_desc">세금계산서 제공여부를 선택해 주세요.</p>
   <div class="account_form">
    <div class="radio">
        <input type="radio" [(ngModel)]="cashbillYn" value="Y" name="taxBill" id="taxBillY" class="form_radio" />
        <label for="taxBillY">제공</label>
    </div>
    <div class="radio">
        <input type="radio" [(ngModel)]="cashbillYn" value="N" name="taxBill" id="taxBillN" class="form_radio" />
        <label for="taxBillN">미제공</label>
    </div>
   </div>
</div>
<div class="popup_content" *ngIf="type == 'regidentNumber'">
   <span class="popup_box_gray account_box" *ngIf="user.regidentNumber">등록된 주민등록번호 : {{user.regidentNumber}}</span>
   <p class="popup_desc">변경할 주민등록번호를 입력해 주세요.</p>
   <div class="account_form">
       <div class="license_input">
        <input type="text" [(ngModel)]="regidentNumberPart1" class="form_input" style="width: 100px !important;" placeholder="000000" maxlength="6" />
        <span class="dash"></span>
        <input type="text" [(ngModel)]="regidentNumberPart2" class="form_input" style="width: 100px !important;" placeholder="0000000" maxlength="7" />
       </div>
   </div>
   <div class="account_form">
        <input type="text" id="attachedFile" class="form_input" placeholder="신분증사본을 첨부해 주세요." readonly [(ngModel)]="licenseFileName" />
        <input type="file" id="controlFiles" name="controlFiles" class="blind" (change)="onFileChange(fileInput.files, $event.target)" #fileInput/>
        <label for="controlFiles" class="form_button btn_required">첨부</label>
   </div>
   <div class="account_form mt-20">
      <p class="form_inner_title">&#8251;대금 지급을 위한 목적으로 개인정보(계좌정보 및 고유식별번호)를 수집 및 이용합니다.</p>
        <div class="check">
            <input type="checkbox" [(ngModel)]="isAgree" id="agreeYn" class="form_check" />
            <label for="agreeYn">[필수] 개인정보 수집 및 이용동의</label>
            <a href="https://www.oasis.co.kr/help/privacy" target="_blank" class="btn_link"><span class="blind">약관 보기</span></a>
        </div>
   </div>
</div>
<div class="popup_content" *ngIf="type == 'updateAccount'">
   <span class="popup_box_gray account_box" *ngIf="userPaymentInfo">등록된 계좌 : {{userPaymentInfo.bankCodeName ?? userPaymentInfo.bankCode}} {{userPaymentInfo.accountNumber}}</span>
   <p class="popup_desc" *ngIf="userPaymentInfo">변경할 계좌의 정보를 입력해 주세요.</p>
   <p class="popup_desc" *ngIf="!userPaymentInfo">수익금 입금이 가능한 계좌의 정보를 정확히 입력해 주세요.</p>
   <div class="form mt-14">
      <div class="select">
            <select class="select_current" [(ngModel)]="bankCode">
              <option value="">::은행선택::</option>
              <option *ngFor="let item of bankCodeList" [value]="item.code" [innerHTML]="item.codeName"></option>
          </select>
      </div>
  </div>
   <div class="account_form">
       <input type="text" class="form_input required" [(ngModel)]="depositor" placeholder="예금주명을 입력해 주세요." />
   </div>
   <div class="account_form">
       <input type="text" class="form_input required" [(ngModel)]="accountNumber" placeholder="계좌번호를 입력해 주세요." />
   </div>
   <div class="account_form">
    <input type="text" id="attachedFile" class="form_input" placeholder="통장사본을 첨부해 주세요." readonly [(ngModel)]="licenseFileName" />
    <input type="file" id="controlFiles" name="controlFiles" class="blind" (change)="onFileChange(fileInput.files, $event.target)" #fileInput/>
    <label for="controlFiles" class="form_button btn_required">첨부</label>
   </div>
   <div class="account_form mt-20">
    <p class="form_inner_title">&#8251;대금 지급을 위한 목적으로 개인정보(계좌정보 및 고유식별번호)를 수집 및 이용합니다.</p>
    <div class="check">
        <input type="checkbox" [(ngModel)]="isAgree" id="agreeYn" class="form_check" />
        <label for="agreeYn">[필수] 개인정보 수집 및 이용동의</label>
        <a href="https://www.oasis.co.kr/help/privacy" target="_blank" class="btn_link"><span class="blind">약관 보기</span></a>
    </div>
</div>
</div>
<div class="popup_content" *ngIf="type == 'updateTel'">
   <span class="popup_box_gray account_box">등록된 핸드폰 번호 : {{user.tel | tel}}</span>
   <div class="account_form">
       <label>핸드폰 번호</label>
       <input type="text" [(ngModel)]="newTel" (keyup.enter)="updateTelOtpSend()" [disabled]="isOtpSend" class="form_input required" placeholder="핸드폰 번호를 입력해 주세요."/>
       <button type="button" class="form_button btn_required" (click)="updateTelOtpSend()" [disabled]="isOtpSend">인증번호</button>
   </div>
   <div class="account_form">
       <label>인증번호 입력</label>
       <input type="text" [(ngModel)]="otpCode" (keyup.enter)="updateTelOtpCheck()" [disabled]="isOtpConfirmTry && isOtpSend" class="form_input required" placeholder="인증번호를 입력해 주세요." />
       <span *ngIf="isOtpSend || isOtpConfirmTry"  class="form_timer">{{displayTime}}</span>
       <button type="button" (click)="updateTelOtpCheck()" [disabled]="!isOtpSend || isOtpConfirm" class="form_button btn_required">확인</button>
       <p *ngIf="isOtpConfirm" class="form_msg col-blue">인증되었습니다.</p>
   </div>
</div>
<div class="popup_content" *ngIf="type == 'updatePassword'">
    <ul class="account_guide">
        <li class="guide_p">비밀번호는 연속된 숫자, 통일 반복된 숫자 등 다른 사람이 쉽게 알아 낼 수 있는 비밀번호는 사용하지 않도록 주의하여 주시기 바랍니다.</li>
        <li class="guide_p">비밀번호는 영문, 숫자를 조합하여 최소 10자리 이상 입력하셔야 합니다. 또한 기존 비밀번호와 동일한 비밀번호는 사용할 수 없습니다.</li>
    </ul>
    <div class="account_form">
        <label>기존 비밀번호</label>
        <input type="password" [(ngModel)]="currentPassword" class="form_input" placeholder="기존 비밀번호를 입력해 주세요."/>
    </div>
    <div class="account_form">
        <label>새 비밀번호</label>
        <input type="password" [(ngModel)]="updatePassword" (keyup)="checkPassword()" class="form_input" placeholder="비밀번호를 입력해 주세요."/>
        <p *ngIf="passwdCheckMsg" class="form_msg">{{passwdCheckMsg}}</p>
    </div>
    <div class="account_form">
        <label>새 비밀번호 확인</label>
        <input type="password" [(ngModel)]="updatePasswordConfirm" (keyup)="checkConfirmPassword()"  class="form_input" placeholder="비밀번호를 한번 더 입력해 주세요."/>
        <p *ngIf="confirmPasswdCheckMsg" class="form_msg">{{confirmPasswdCheckMsg}}</p>
    </div>
</div>
<div class="popup_content w380" *ngIf="type == 'gradeInfo'">
  <span class="grade_image">
    <img *ngIf="isShowEventBanner" src="/assets/images/web/img/img_grade_250415.png" alt="등급안내" />
    <img *ngIf="!isShowEventBanner" src="/assets/images/web/img/img_grade_250531.png" alt="등급안내" />
  </span>
  <!-- <div class="grade_wrap">
      <strong class="grade_title">오아시스버디 등급별 수수료 안내</strong>
      <p class="grade_desc">등급 별 추가 혜택(장보기포인트, 활동비 등) 은 준비 중으로 <br />순차적으로 업데이트될 예정입니다.</p>
      <span class="grade_img"><img src="/assets/images/web/img/img_grade.png" alt="이웃등급 3%, 파워등급 5%" /></span>
      <div class="grade_box">
          <div class="grade_info grade-1">
              <div class="grade_reward">
                  <span class="grade_badge">이웃등급</span> <span class="grade_percent">구매 금액의 3%를 <br />리워드로 제공</span>
              </div>
              <ul class="info_list">
                  <li class="info_item">유튜브 구독자 1천명 이상</li>
                  <li class="info_item">인스타그램 팔로워 1천명 이상</li>
                  <li class="info_item">블로그 직전월 순방문자 1만명 이상</li>
              </ul>
              <p class="info_text">조건 중 <span class="col-blue">1개 이상</span> 해당되는 계정</p>
          </div>
          <div class="grade_info grade-2">
              <div class="grade_reward">
                  <span class="grade_badge">파워등급</span> <span class="grade_percent">구매 금액의 5%를 <br />리워드로 제공</span>
              </div>
              <ul class="info_list">
                  <li class="info_item">유튜브 구독자 1만명 이상</li>
                  <li class="info_item">인스타그램 팔로워 1만명 이상</li>
                  <li class="info_item">블로그 직전월 순방문자 10만명 이상</li>
              </ul>
              <p class="info_text">조건 중 <span class="col-blue">1개 이상</span> 해당되는 계정</p>
          </div>
      </div>
  </div> -->
</div>
<div class="popup_footer" *ngIf="type != 'gradeInfo'"><!-- 개발요청::등급 수수료 안내 팝업인 경우 비노출 -->
  <button type="button" class="btn_item btn-close" (click)="popupClose()">취소</button>
  <button type="button" class="popup_close btn_item btn-primary" (click)="proc()">{{buttonTitle}}</button>
</div>
